import { apiFetch } from './client'
import type { Patient, PatientCreate, PatientListResponse, PatientUpdate } from '../types/patients'

export async function listPatients(params: {
  client_id?: number
  search?: string
  limit?: number
  offset?: number
}): Promise<PatientListResponse> {
  const qs = new URLSearchParams()
  if (params.client_id !== undefined) qs.set('client_id', String(params.client_id))
  if (params.search) qs.set('search', params.search)
  if (params.limit !== undefined) qs.set('limit', String(params.limit))
  if (params.offset !== undefined) qs.set('offset', String(params.offset))
  const res = await apiFetch(`/api/patients?${qs.toString()}`)
  if (!res.ok) throw new Error('Failed to load patients')
  return res.json() as Promise<PatientListResponse>
}

export async function getPatient(id: number): Promise<Patient> {
  const res = await apiFetch(`/api/patients/${id}`)
  if (res.status === 404) throw new Error('Patient not found')
  if (!res.ok) throw new Error('Failed to load patient')
  return res.json() as Promise<Patient>
}

export async function createPatient(data: PatientCreate): Promise<Patient> {
  const res = await apiFetch('/api/patients', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: unknown }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to create patient')
  }
  return res.json() as Promise<Patient>
}

export async function updatePatient(id: number, data: PatientUpdate): Promise<Patient> {
  const res = await apiFetch(`/api/patients/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to update patient')
  return res.json() as Promise<Patient>
}

export async function uploadPatientPhoto(id: number, file: File): Promise<Patient> {
  const form = new FormData()
  form.append('photo', file)
  const res = await apiFetch(`/api/patients/${id}/photo`, { method: 'POST', body: form })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to upload photo')
  }
  return res.json() as Promise<Patient>
}

export async function deletePatientPhoto(id: number): Promise<Patient> {
  const res = await apiFetch(`/api/patients/${id}/photo`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to remove photo')
  return res.json() as Promise<Patient>
}
